module.exports = __webpack_public_path__ + "img/couples-079.40779f26.jpg";